/**
 * Invokes callback when DOM is ready
 *
 * @param {Callback} callback The callback
 */
const onReady = ( callback ) => {
	// If the document isn't ready yet, add the event listener
	// eslint-disable-next-line @wordpress/no-global-event-listener
	document.addEventListener( 'DOMContentLoaded', callback );

	// If it's already loaded, invoke
	if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
		callback();
	}
};

export default onReady;
